import axios, { AxiosResponse } from 'axios'
import { useEffect, useState } from 'react'
import { usCountryList, europeCountryList } from '@/utils/geo-location/geo-location.util'

const useGeoLocation = (locationAccess: boolean) => {
  const [location, setLocation] = useState({
    loaded: false,
    coordinates: { lat: '', lng: '' },
    locale: '',
    countryCode: '',
    error: {},
  })

  // Free GEOCODE API client to get country code
  // Reference Link: https://www.bigdatacloud.com/docs/api/free-reverse-geocode-to-city-api
  const REVERSE_GEOCODE_CLIENT: string =
    'https://api.bigdatacloud.net/data/reverse-geocode'

  const onSuccess = async (location: {
    coords: { latitude: any; longitude: any }
  }) => {

    if (locationAccess) {
      let res: AxiosResponse
      let locale: string = 'en-us'
      let countryCode
      try {
        res = await axios.get(
          `${REVERSE_GEOCODE_CLIENT}?latitude=${location.coords.latitude}&longitude=${location.coords.longitude}&localityLanguage=en&key=bdc_74c2e51064394af28e7e5fd320069911`
          // `${REVERSE_GEOCODE_CLIENT}?latitude=45.5019&longitude=-73.5674&localityLanguage=en`
        )

        if (res && res.data && Object.keys(res.data).length) {

          countryCode = res.data.countryCode

          if (process.env.SITE_BRAND != 'elavon') {
            // We are not on Elavon's site
            // we need to determine if we are in Quebec to serve region-specific content in french
            if (countryCode === 'CA' && res.data.principalSubdivision === 'Quebec') {
              console.log("We're in Quebec. En francais s'il vous plait")
              locale = 'fr-ca'
            } else {
              // for usbank sites, default to 'en-us' for all locations outside Quebec
              locale = 'en-us'
            }

          } else {
            // we're on Elavon's site
            if (usCountryList.includes(countryCode)) {
              locale = 'en-us'
            } else if (europeCountryList.includes(countryCode)) {
              locale = 'en-gb'
            } else {
              locale = 'en-oc'
              countryCode = 'OC'
            }  
          }
        }
      } catch (error) {
        console.log('Error connecting to Geocode API')
      }   

      setLocation({
        loaded: true,
        coordinates: {
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        },
        locale,
        countryCode,
        error: {}, 
      })
    }
  }

  const onError = (error: { code: any; message: any }) => {
    setLocation({
      loaded: true,
      coordinates: { lat: '', lng: '' },
      locale: 'en-us',
      countryCode: 'US',
      error: {
        code: error.code,
        message: error.message,
      },
    })
  }

  useEffect(() => {
    if (!('geolocation' in navigator)) {
      onError({
        code: 0,
        message: 'Geolocation not supported',
      })
    }

    if (locationAccess) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError)
    }
  }, [locationAccess])

  return location
}

export default useGeoLocation
